export default __webpack_public_path__ + "static/media/a012-market-line-9.d5b5cc07.svg";